import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import {
  masterFulfillmentListUrl,
  masterFulfillmentUrl,
  OrderListUrlQueryParams,
  OrderListUrlSortField,
  OrderUrlQueryParams
} from "@saleor/motherOrders/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React, { FC } from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import MasterFulfillmentComponent from "../masterFulfillment/views/MasterFulfillment";
import OrderDetailsComponent from "../motherOrders/views/OrderDetails";

const MasterFulfillmentList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params = asSortParams(
    qs,
    OrderListUrlSortField,
    OrderListUrlSortField.date,
    false
  ) as OrderListUrlQueryParams;

  return <MasterFulfillmentComponent params={params} />;
};

const MasterFulfillmentDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<OrderUrlQueryParams>(
    location.search.substring(1)
  );

  return (
    <OrderDetailsComponent
      id={decodeURIComponent(id)}
      params={params}
      backUrlRedirect={masterFulfillmentListUrl()}
      detailsUrl={masterFulfillmentUrl}
    />
  );
};

const Component: FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.fulfillment)} />
      <Routes>
        <Route path={""} element={<MasterFulfillmentList />} />
        <Route path={":id"} element={<MasterFulfillmentDetails />} />
      </Routes>
    </>
  );
};

export default Component;
